import React from "react";
import { useIntl } from "react-intl";
import { BusyTimes } from "./BusyTimes";
import { RegularTime } from "./RegularTime";
import { DashboaredHeaderBanner } from "../../../../components/sharedComponents/DashboaredHeaderBanner";

export const PublicReserv = () => {
    const { messages } = useIntl();
    return (
        <div className="profile">
            <div className="container-fluid">
                {/* <div className="head_box mb-4">
                    <h2 className="heading_dash mb-1">
                        {messages["edit_available_reservations"]}
                    </h2>
                    <p className="heading_dis">
                        {messages["edit_available_info"]}
                    </p>
                </div> */}
                <DashboaredHeaderBanner
                    text={messages["edit_available_reservations"]}
                    description={messages["edit_available_info"]}
                />

                <div className="row mt-4">
                    <div className="col-12 col-md-7">
                        <RegularTime />
                    </div>
                    <div className="col-md-5">
                        <BusyTimes />
                    </div>
                    {/* <div className="col-md-5">
            <CustomTime />
          </div> */}
                </div>
            </div>
        </div>
    );
};
